import { PostManualUpload } from "services/apiService";
import {
  UPLOAD_RECEIPT_FILE_REQUEST,
  UPLOAD_RECEIPT_FILE_SUCCESS,
  UPLOAD_RECEIPT_FILE_ERROR,
  RESET_UPLOAD_RECEIPT_FILE,
} from "./action-type";
import { SOMS_API_KEY, UPLOAD_RECEIPT_FILE_ENDPOINT } from "services/CONSTANTS";

export const uploadReceiptFile = (payload) => {
  const { params } = payload;
  const apiEndPointUrl = `${UPLOAD_RECEIPT_FILE_ENDPOINT}?apikey=${SOMS_API_KEY}`;
  return (dispatch) => {
    dispatch({ type: UPLOAD_RECEIPT_FILE_REQUEST });
    PostManualUpload(apiEndPointUrl, params)
      .then((response) => {
        if (response.status === 200)
          dispatch(uploadReceiptFileSuccess(response));
        else dispatch(uploadReceiptFileError(response));
      })
      .catch((err) => {
        dispatch(uploadReceiptFileError(err));
      });
  };
};

export const uploadReceiptFileSuccess = (response) => ({
  type: UPLOAD_RECEIPT_FILE_SUCCESS,
  uploadReceiptFileResponse: response.data,
  isUploadReceiptFileError: false,
  isUploadReceiptFileSuccess: true,
  errorDetails: {},
});

export const uploadReceiptFileError = (error) => ({
  type: UPLOAD_RECEIPT_FILE_ERROR,
  uploadReceiptFileResponse: error,
  isUploadReceiptFileError: true,
  isUploadReceiptFileSuccess: false,
  errorDetails: error,
});

export const resetUploadReceiptFile = () => ({
  type: RESET_UPLOAD_RECEIPT_FILE,
});
